import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogin } from "@/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await adminLogin(username, password);
      localStorage.setItem("hg_admin_token", data.token);
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 bg-paper" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm border border-line p-8 md:p-10" data-testid="admin-login-form">
        <p className="text-xs uppercase tracking-[0.28em] text-muted mb-2">Heda Gelogaeva</p>
        <h1 className="font-display text-4xl mb-8">Owner Login</h1>

        <label className="text-[10px] uppercase tracking-[0.22em] text-muted">Username</label>
        <input
          type="text" required value={username} onChange={(e) => setUsername(e.target.value)}
          data-testid="admin-email"
          className="mt-2 mb-6 w-full bg-transparent border-b border-line py-2 text-lg font-light focus:outline-none focus:border-ink transition-colors"
        />
        <label className="text-[10px] uppercase tracking-[0.22em] text-muted">Password</label>
        <input
          type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
          data-testid="admin-password"
          className="mt-2 mb-6 w-full bg-transparent border-b border-line py-2 text-lg font-light focus:outline-none focus:border-ink transition-colors"
        />

        {error && <p className="text-sm text-red-600 mb-4" data-testid="admin-login-error">{error}</p>}

        <button
          type="submit" disabled={loading} data-testid="admin-login-submit"
          className="w-full bg-ink text-paper py-4 text-xs uppercase tracking-[0.2em] transition-colors duration-500 hover:bg-accent hover:text-ink disabled:opacity-60"
        >
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
